import {Component, OnInit} from '@angular/core';
import {AuthService} from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'File Encryption';
  userName: string = null;

  constructor(private authService: AuthService) {
  }

  ngOnInit(): void {
     this.authService.currentUserStatus$.subscribe({
      next: response => {
         this.userName = response?.profile?.name;
     }
   });
  }
}
